document.addEventListener("DOMContentLoaded", function () {
  // Hamburger Menu Toggle
  const hamburgerMenu = document.querySelector(".hamburger-menu");
  if (hamburgerMenu) {
    hamburgerMenu.addEventListener("click", function () {
      document.querySelectorAll(".bar").forEach((bar) => bar.classList.toggle("animate"));
      document.querySelector(".mobile-menu").classList.toggle("active");
      return false;
    });
  }

  // Dropdown with Children Toggle
  document.querySelectorAll(".downarrow").forEach((element) => {
    element.addEventListener("click", function (event) {
      event.preventDefault();
    });
  });

  // Hero Carousel Initialization
  $(function () {

    $('[data-element="heroslider"]').owlCarousel({
      items: 1,
      margin: 20,
      loop: true,
      nav: true,
      dots: false,
      autoplay: true,
    });

    const itemCount = $(".hero-owlCarousel .owl-item").not(".cloned").length;
    if (itemCount < 2) {
      $(".hero-owlCarousel .owl-nav").hide(); // Hide navigation arrows
    }

    // Services Carousel
    $(".carousel-services").owlCarousel({
      items: 4,
      margin: 20,
      loop: true,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1, nav: true },
        600: { items: 2, nav: false },
        1000: { items: 4, nav: true, loop: false },
      },
    });

    // Referral Hospital Carousel
    $(".referral-hospial").owlCarousel({
      items: 4,
      margin: 20,
      loop: true,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplaySpeed: 500,
      smartSpeed: 500,
      dots: false,
      responsive: {
        0: { items: 1, nav: true },
        600: { items: 2, nav: false },
        1000: { items: 4, nav: true, loop: false },
      },
    });

    // Tab Navigation
    if ($('[data-block="ourusp"]').length > 0) {
      $(".tab-content").hide();
      if ($(".mobile-device").length === 0) {
        $("#tabs-nav li:first-child").addClass("active");
        $(".tab-content:first").show();
      }

      $("#tabs-nav li").click(function () {
        $("#tabs-nav li").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").hide();
        const activeTab = $(this).find("a").attr("href");
        $(activeTab).fadeIn();
        return false;
      });
    }

    // Dropdown Handling
    const dropdownWrappers = document.querySelectorAll(".dropdown-wrapper");
    dropdownWrappers.forEach((dropdownWrapper) => {
      const dropdowns = dropdownWrapper.querySelectorAll(".dropdown");
      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("click", function () {
          dropdown.classList.toggle("active");
          dropdownWrapper.querySelectorAll(".dropdown.active").forEach((activeDropdown) => {
            if (activeDropdown !== dropdown) activeDropdown.classList.remove("active");
          });
        });
      });
    });

    // Column Menu Interaction
    $(document).on("click", ".column-menu-item", function () {
      const thisID = $(this).data("id");
      $(".column-menu-item").removeClass("active");
      $(this).addClass("active");
      $(".column-menu-list").removeClass("active");
      $(`[data-content="${thisID}"]`).addClass("active");
    });

    // Callback Form Submission with Validation
    const formCRM = document.querySelector(".banner-form");
    if (formCRM) {
      formCRM.addEventListener("submit", function (e) {
        e.preventDefault();

        let isValid = true;

        // Clear previous errors
        document.querySelectorAll(".error-message").forEach((error) => {
          error.textContent = "";
          error.style.display = "none";
        });

        document.querySelectorAll(".field input").forEach((input) => {
          input.classList.remove("error");
        });

        const fullname = document.getElementById("fullname").value.trim();
        const phoneno = document.getElementById("phoneno").value.trim();

        // Fullname validation
        if (fullname === "") {
          const fullnameError = document.getElementById("fullname-error");
          fullnameError.textContent = "Please enter your full name.";
          fullnameError.style.display = "block";
          document.getElementById("fullname").classList.add("error");
          isValid = false;
        }

        // Phone number validation
        if (phoneno === "") {
          const phonenoError = document.getElementById("phoneno-error");
          phonenoError.textContent = "Please enter your phone number.";
          phonenoError.style.display = "block";
          document.getElementById("phoneno").classList.add("error");
          isValid = false;
        } else if (!/^[0-9]{10}$/.test(phoneno)) {
          const phonenoError = document.getElementById("phoneno-error");
          phonenoError.textContent = "Please enter a valid 10-digit phone number.";
          phonenoError.style.display = "block";
          document.getElementById("phoneno").classList.add("error");
          isValid = false;
        }

        // Stop form submission if validation fails
        if (!isValid) return;

        // AJAX request using Fetch API
        fetch(webwp.ajaxurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            action: "book_ambulance",
            fullname: fullname,
            phoneno: phoneno,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            formCRM.reset();
            if (data.success) {
              document.getElementById("crm_response").innerHTML = `our representative will contact you in 5 seconds.`;
            } else {
              document.getElementById("crm_response").innerHTML = `There seems to be a technical issue. Please try again.`;
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            document.getElementById("crm_response").innerHTML = `There seems to be a technical issue. Please try again.`;
          });
      });
    }

    // Counter Animation
    function animateCounter(element) {
      $(element).prop("Counter", 0).animate(
        {
          Counter: $(element).text(),
        },
        {
          duration: 4000,
          easing: "swing",
          step: function (now) {
            now = Number(Math.ceil(now)).toLocaleString("en");
            $(this).text(now);
          },
        }
      );
    }

    // Intersection Observer for Counters
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });

    $(".webwp-counter").each(function () {
      observer.observe(this);
    });
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js